<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'About'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body about-modal">
    <div class="site-code">{{'Site Code' | translate | async}} : {{SiteCode}}</div>
    <div class="site-code">Version  : {{version}}</div>
    <div class="copy-right"> Copyright 
      &copy;
   {{CurrentYear}}
    </div>
    <div class="company-name"> TT Software Services PTY. LTD. </div>
    <div class="email"> <a href="mailto:help@tracktreads.com">{{ContactInfoEmail}}</a> </div>

  </div>
  <div class="ttmodal__footer ok-button">
    <button  mat-raised-button color="warn" (click)="onNoClick()">Ok</button>
  </div>
</div>
